
(function () {
  const BTN_SELECTOR = '[data-gl-drawer-add][data-variant-id]';

  function getCartOpener() {
    return (
      document.querySelector('.header__icon--cart') ||
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('a[aria-label*="panier" i]') ||
      document.querySelector('button[aria-label*="panier" i]') ||
      document.querySelector('a[aria-controls*="cart" i]') ||
      document.querySelector('button[aria-controls*="cart" i]') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href="/cart/"]')
    );
  }

  function getDrawerRoot() {
    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('.cart-drawer')
    );
  }

  function getCartIconRoot() {
    return (
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('[data-cart-count]') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href="/cart/"]')
    );
  }

  function getSectionIdFromShopifySectionEl(el) {
    if (!el) return null;
    const sectionEl = el.closest('.shopify-section');
    if (!sectionEl) return null;
    const id = sectionEl.getAttribute('id') || '';
    return id.startsWith('shopify-section-') ? id.replace('shopify-section-', '') : null;
  }

  async function addToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!res.ok) throw new Error('add.js failed: ' + res.status);
    return res.json();
  }

  async function getCartJson() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('cart.js failed: ' + res.status);
    return res.json();
  }

  async function fetchSections(sectionIds) {
    const uniq = Array.from(new Set(sectionIds.filter(Boolean)));
    if (!uniq.length) return {};
    const url = `/?sections=${encodeURIComponent(uniq.join(','))}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('sections fetch failed: ' + res.status);
    return res.json(); // { sectionId: "<html>...</html>", ... }
  }

  function toast(msg) {
    let el = document.getElementById('gl-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'gl-cart-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);

      const style = document.createElement('style');
      style.textContent = `
        #gl-cart-toast{
          position: fixed; left: 50%; top: 14px; transform: translateX(-50%);
          background: rgba(31,59,92,.92); color: #fff;
          padding: 10px 12px; border-radius: 999px;
          font-size: 13px; z-index: 999999;
          opacity: 0; pointer-events: none;
          transition: opacity .15s ease, transform .15s ease;
        }
        #gl-cart-toast.is-on{ opacity: 1; transform: translateX(-50%) translateY(2px); }
      `;
      document.head.appendChild(style);
    }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(window.__glToastTimer);
    window.__glToastTimer = setTimeout(() => el.classList.remove('is-on'), 1200);
  }

  function dispatchAtelierCartUpdate(cart, sourceId, sectionsMap, extraData) {
    // Atelier: ThemeEvents.cartUpdate = 'cart:update'
    const detail = {
      resource: cart,
      sourceId: sourceId || 'gl-complete-look',
      data: Object.assign(
        {
          source: 'gl-complete-look',
          itemCount: cart?.item_count,
          sections: sectionsMap || {} // IMPORTANT: the theme expects this
        },
        extraData || {}
      )
    };

    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
  }

  function ensureDrawerOpens() {
    // Many Atelier setups open automatically on cart:update if the drawer has auto-open.
    // If not, we click the header cart icon as a fallback.
    const opener = getCartOpener();
    if (opener && opener.click) opener.click();
  }

  document.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest(BTN_SELECTOR);
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      if (btn.disabled) return;
      btn.disabled = true;

      try {
        await addToCart(variantId);
        toast('Ajouté au panier');

        const cart = await getCartJson();

        // Build the sections map the theme expects
        const drawerRoot = getDrawerRoot();
        const cartIconRoot = getCartIconRoot();
        const drawerSectionId = getSectionIdFromShopifySectionEl(drawerRoot);
        const cartIconSectionId = getSectionIdFromShopifySectionEl(cartIconRoot);

        const sectionsMap = await fetchSections([drawerSectionId, cartIconSectionId]);

        // Let Atelier handle DOM updates itself (NO manual replace → no “Panier vide”/glitch)
        dispatchAtelierCartUpdate(cart, 'gl-complete-look', sectionsMap, {
          variantId: String(variantId)
        });

        // Open drawer after the theme receives the event
        requestAnimationFrame(() => {
          ensureDrawerOpens();
        });
      } catch (err) {
        console.warn('[gl-drawer-add] error', err);
        toast("Erreur d'ajout");
      } finally {
        btn.disabled = false;
      }
    },
    true
  );
})();